<template>
  <el-row>
    <el-col :span="12" class="p-r-sm">
      <el-form-item :prop="prop[0]">
        <el-select
          clearable
          filterable
          :value="value.length ? value[0] : ''"
          :multiple="isMultiple[0]"
          @change="(val) => handleChange(val, 0, prop[0])"
        >
          <el-option
            v-for="(item, index) in options1"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12" class="p-l-sm">
      <el-form-item :prop="prop[1]">
        <el-select
          clearable
          filterable
          :multiple="isMultiple[1]"
          :value="value.length ? value[1] : ''"
          @change="(val) => handleChange(val, 1, prop[1])"
        >
          <el-option
            v-for="(item, index) in options2"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },
      options1: {
        type: Array,
        default: () => [],
      },
      options2: {
        type: Array,
        default: () => [],
      },
      prop: {
        // 可选，绑定form-item的prop
        type: Array,
        default: () => [],
      },
      isMultiple: {
        type: Array,
        default: () => [false, false],
      },
    },
    methods: {
      handleChange(val, type, key) {
        const value = this.value || [];
        value[type] = val;
        this.$emit('input', value);
        this.$emit('change', key, val);
      },
    },
  };
</script>
